import { Layout, Tag } from '@loadsmart/miranda-react'

import { AppointmentStatus } from 'core/appointments/ui/AppointmentStatus'
import { type Stop, isDelivery, isPickup } from 'core/domain/Stop'
import { formatType } from 'core/presenters/stopPresenter'
import { TimelineItem, type TimelinePosition } from 'core/ui/components/timeline/TimelineItem'

import { LoadStopAddress } from './LoadStopAddress'

export type LoadStopsProps = {
  stops: Array<Stop>
}

export function LoadStops({ stops }: LoadStopsProps) {
  return (
    <Layout.Stack gap="none">
      {stops.map((stop, index) => {
        let position: TimelinePosition = 'middle'

        if (isPickup(index)) {
          position = 'first'
        } else if (isDelivery(index, stops)) {
          position = 'last'
        }

        return (
          <TimelineItem key={`stop-${stop.city}-${stop.state}`} position={position}>
            <Layout.Stack gap="spacing-2">
              <Tag variant="neutral" size="small" style={{ display: 'block' }}>
                {formatType(index, stops)}
              </Tag>
              <LoadStopAddress stop={stop} />
              <AppointmentStatus appointment={stop.appointment} />
            </Layout.Stack>
          </TimelineItem>
        )
      })}
    </Layout.Stack>
  )
}
